<div class="modal-header" style="flex-direction: column; align-items: flex-start">
  <h4 class="modal-title" id="exampleModalLabel">
    {{ "campaignDetails.viewApprobation" | translate }}
  </h4>
  <p style="margin: 0" *ngIf="!isLocation">{{ campaignName }}</p>
  <p style="margin: 0" *ngIf="isLocation">{{ locationName }}</p>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <div id="progress" *ngIf="!isLocation">
    <div class="step" *ngFor="let step of steps; let i = index"
         [class.muted]="isMuted(i)">
      <div class="circle"
           [class.completed]="isCompleted(i)"
           [class.current]="isCurrent(i)"
           [class.warning]="isWarning(i)"
           [class.failed]="isFailed(i)"
           [class.muted]="isMuted(i)">

        <!-- Completed = tick -->
        <ng-container *ngIf="isCompleted(i)">
          <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4.64 10.904L0 6.264L1.624 4.64L4.64 7.656L12.296 0L13.92 1.624L4.64 10.904Z" fill="white"/>
          </svg>
        </ng-container>

        <!-- Warning = exclamation (your SVG) -->
        <ng-container *ngIf="isWarning(i)">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M9 3.85718V9.00003" stroke="white" stroke-width="2.57143" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 14.1428H9.01286" stroke="white" stroke-width="2.57143" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </ng-container>

        <!-- Failed (final X) — your SVG -->
        <ng-container *ngIf="isFailed(i)">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M11.1998 2.80005L2.7998 11.2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.7998 2.80005L11.1998 11.2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </ng-container>
      </div>

      <div class="content">
        <!-- pass the index to show the canceled copy on the last step -->
        <div class="title">{{ getTitle(step, i) | translate }}</div>
        <div class="description">{{ getDescription(step, i) | translate }}</div>
      </div>
    </div>
  </div>
  <div id="progress" *ngIf="isLocation">
    <div class="step">         
      <div class="circle"
        [class.completed]="true"
      >
        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M4.64 10.904L0 6.264L1.624 4.64L4.64 7.656L12.296 0L13.92 1.624L4.64 10.904Z" fill="white"/>
        </svg>
      </div>
      <div class="content">
        <div class="title">{{ "locationApprobation.step1.title" | translate }}</div>
        <div class="description">{{ "locationApprobation.step1.description" | translate }}</div>
      </div>
    </div>
    <div class="step">         
      <div class="circle"
        [class.completed]="isActiveLocation"
        [class.current]="!isActiveLocation"
      >
        <ng-container *ngIf="isActiveLocation">
          <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4.64 10.904L0 6.264L1.624 4.64L4.64 7.656L12.296 0L13.92 1.624L4.64 10.904Z" fill="white"/>
          </svg>
        </ng-container>
      </div>
      <div class="content">
        <div class="title">{{ "locationApprobation.step2.title" | translate }}</div>
        <div class="description">{{ "locationApprobation.step2.description" | translate }}</div>
      </div>
    </div>
    <div class="step">         
      <div class="circle"
        [class.completed]="isActiveLocation"
        [class.muted]="!isActiveLocation"
      >
        <ng-container *ngIf="isActiveLocation">
          <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4.64 10.904L0 6.264L1.624 4.64L4.64 7.656L12.296 0L13.92 1.624L4.64 10.904Z" fill="white"/>
          </svg>
        </ng-container>
      </div>
      <div class="content">
        <div class="title">{{ "locationApprobation.step3.title" | translate }}</div>
        <div class="description">{{ "locationApprobation.step3.description" | translate }}</div>
      </div>
    </div>
  </div>
</div>


<div class="modal-footer">
  <button type="button" class="btn btn-primary close-btn" data-bs-dismiss="modal" (click)="closeModal()">
    {{ "buttons.close" | translate }}
  </button>
</div>
